import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Database } from "@/integrations/supabase/types";

type MedicalRecordRow = Database["public"]["Tables"]["medical_records"]["Row"];

type MedicalRecordWithRelations = MedicalRecordRow & {
  pets?: {
    id: string;
    name: string;
    owners?: {
      id: string;
      name: string;
    } | null;
  } | null;
  profiles?: {
    id: string;
    full_name: string | null;
  } | null;
  clinics?: {
    id: string;
    name: string | null;
  } | null;
};

export const useMedicalRecord = (id?: string) => {
  return useQuery({
    queryKey: ["medical-record", id],
    enabled: Boolean(id),
    queryFn: async () => {
      const { data, error } = await supabase
        .from("medical_records")
        .select(
          `
            *,
            pets (
              id,
              name,
              owners (
                id,
                name
              )
            ),
            profiles!fk_vet_user (
              id,
              full_name
            ),
            clinics (
              id,
              name
            )
          `,
        )
        .eq("id", id)
        .is("deleted_at", null)
        .single();

      if (error) throw error;
      return data as MedicalRecordWithRelations;
    },
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
};

export type MedicalRecordDetails = MedicalRecordWithRelations;
